import React, { useEffect, useState,useRef } from 'react'
import ShippingMethod from './shippingmethod'
import partsService from "../../../../services/partsservice";
import helperfunctions from '../../../../utils/helperfunctions';
import { containerIprops } from './shippingmethodinterface';
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from '../../../../state/features/header';
import { RESOURCE } from '../../../../const/resource';
import { useTranslation } from 'react-i18next';

const ShippingMethodContainer = (props: containerIprops) => {
    const { t } = useTranslation();
    const { stepperDetails, cartsDetails }: ICartContextType = useCartContext();
    const [shippingMethods, setShippingMethods] = useState<any>({ loading: false, data: {} });
    const defaultOption = { value: '', title: t(RESOURCE.MyK_Please_Select) };

    const {
        headercurrentuser
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state)
        })
    );

    useEffect(() => {
        getShippingMethods();
    }, []);

    useEffect(() => {
        if (shippingMethods?.data?.shippingWarning && !stepperDetails?.shipment?.shippingCostWarning) {
            props?.updateShipmentDetails({ ...stepperDetails?.shipment, shippingCostWarning: shippingMethods?.data?.shippingWarning })
        }
    }, [shippingMethods, stepperDetails?.shipment]);

    useEffect(() => {
        if (stepperDetails?.shipment?.shippingMethodId) {
            props?.getShippingCarriers(stepperDetails?.shipment?.shippingMethodId);
        }
    }, [stepperDetails?.shipment?.shippingMethodId, stepperDetails?.shipment?.addressId]);

    const getShippingMethods = async () => {
        try {
            const reqBody = {
                cartId: cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? ''
            }
            setShippingMethods({ loading: true, data: {} });
            const response = await partsService.getShippingMethods(reqBody);
            if (response?.isSuccess) {
                const data = response?.data?.shippingMethodDetail?.map((t: any) => ({ title: t.shippingMethod, value: t.shippingMethodId }))  ?? [];
                const updatedResponse =  { ...response?.data, shippingMethodDetail: [defaultOption, ...data] } ;
                setShippingMethods({ loading: false, data: updatedResponse ?? {} });
            } else {
                setShippingMethods({
                    loading: false, data: {}
                });
                helperfunctions.showErrorMessage(`${response?.msg}`);
            }
        } catch (error) {
            setShippingMethods({
                loading: false, data: {}
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    };

    const ifMandatoryFieldsEmpty = (shipment: any) => {
        const { address1, countryCode, stateCode, city, postalCode } = shipment;
    
        return !address1 || !countryCode || !stateCode || !city || !postalCode;
    };

    const handleMethodChange = (e: any, type: any) => {
        const errorObj = { ...stepperDetails?.shipment?.error, isReqForShippingMethod: false };
        if (type == "shippingMethodId") {
            const isEmpty = ifMandatoryFieldsEmpty(stepperDetails?.shipment);
            props.setShippingCarries({ loading: false, data: {} });
            if (!isEmpty) {
                const shippingMethodObj = shippingMethods?.data?.shippingMethodDetail?.find((method: any) => method?.value == e);
                const shippingMethodName = shippingMethodObj?.title?.toLowerCase();
                const showShippingMethodWarning = shippingMethodName == "delivery" || shippingMethodName == "dropbox" || shippingMethodName == "freight truck";
                const err = { ...errorObj, shippingMethodId: false, isReqForShippingMethod: false };
                props?.updateShipmentDetails({ ...stepperDetails?.shipment, ...shippingMethodObj, showShippingMethodWarning: showShippingMethodWarning, shippingMethodId: e ?? '', error: err, serviceTypeId: "", carrierCode:"" });
            } else {
                const err = { ...errorObj, isReqForShippingMethod: true };
                props?.updateShipmentDetails({ ...stepperDetails?.shipment, showShippingMethodWarning:false, shippingMethodId: '', error: err });
            }
        }
    };

    const handleCarrierChange = (serviceTypeId: any, carrierCode: any) =>
    {
        props.updateShipmentData(serviceTypeId ?? '', carrierCode?? '', { ...stepperDetails?.shipment });
    }

    const mandatoryFieldRef = useRef<HTMLInputElement>(null);

    const scrollToErrorField = () => {
      mandatoryFieldRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center', // Adjust to 'start' or 'end' if needed`
      });
    };

    useEffect(() => {
        if (stepperDetails?.shipment?.error?.shippingMethodId) {
            const otherErrorsCount = Object.values(stepperDetails?.shipment?.error).filter(error => error).length;
            if(otherErrorsCount === 1) {
                scrollToErrorField();
            }
        }
    }, [props?.isNextClick])


    return (
        <ShippingMethod
            isKomatsuOnly={props?.isKomatsuOnly}
            shippingMethods={shippingMethods}
            shippingCarries={props.shippingCarries}
            handleMethodChange={handleMethodChange}
            shipmentDetails={props?.shipmentDetails}
            getDivRef={props?.getDivRef}
            getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}
            mandatoryFieldRef={mandatoryFieldRef}
            updateSelectedCarrier={props?.updateSelectedCarrier}
            selectedCarrier={props?.selectedCarrier}
            getShippingCarriers={props?.getShippingCarriers}
            updateShipmentData={props?.updateShipmentData}
            isEstimatedCostDisabled={props?.isEstimatedCostDisabled}
            setIsServiceTypeRequired={props?.setIsServiceTypeRequired}
            handleCarrierChange={handleCarrierChange}
        />
    )
}

export default ShippingMethodContainer